module.exports = __webpack_public_path__ + "assets/paytm.6169562899cacd4a17770cc67f6dddb3.svg";